import React, { useState } from "react";
import InvoiceItem from "./InvoiceItem";
import DoctorPayment from "./DoctorPayment";
import SurgeyPackage from "./SurgeyPackage";
import OpdPayout from "./OpdPayout";
import ReferalPayout from "./ReferalPayout";

function DashboardMain() {
  const [activeTab, setActiveTab] = useState("surgeryPackage");
  const handleLogout = () => {
    localStorage.removeItem("token"); // Remove the token
    window.location.href = "/"; // Redirect to login
  };

  return (
    <div className="App">
      <div style={styles.header}>
        <img
          style={styles.appTitle}
          src={`${process.env.PUBLIC_URL}/pred_logo.png`}
          alt="Logo"
          className="logo"
        />
        <button style={styles.logoutButton} onClick={() => handleLogout()}>
          Logout
        </button>
      </div>

      {/* Tab Navigation */}
      <div className="tab-container" style={styles.tabContainer}>
        <button
          style={activeTab === "surgeryPackage" ? styles.activeTab : styles.tab}
          onClick={() => setActiveTab("surgeryPackage")}
        >
          IPD Doctor Payout
        </button>
        <button
          style={activeTab === "opd" ? styles.activeTab : styles.tab}
          onClick={() => setActiveTab("opd")}
        >
          OPD Doctor Payout
        </button>
      </div>

      {/* Tab Content */}
      <div style={styles.tabContent}>
        {activeTab === "surgeryPackage" && <SurgeyPackage />}
        {activeTab === "opd" && <OpdPayout />}
        {activeTab === "referal" && <ReferalPayout />}
      </div>
    </div>
  );
}

const styles = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "15px 30px",
    borderBottom: "1px solid #ddd",
    backgroundColor: "#f8f9fa",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  },
  appTitle: {
    margin: 0,
    fontSize: "1.8rem",
    fontWeight: "bold",
    color: "#343a40",
  },
  logoutButton: {
    backgroundColor: "#f44336",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    padding: "10px 20px",
    cursor: "pointer",
    fontSize: "1rem",
    transition: "background-color 0.3s ease",
  },
  logoutButtonHover: {
    backgroundColor: "#d32f2f",
  },
  tabContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "20px",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    backgroundColor: "#fff",
    padding: "10px 20px",
  },
  tab: {
    padding: "12px 30px",
    margin: "0 10px",
    backgroundColor: "#f1f3f5",
    border: "1px solid #ddd",
    borderRadius: "20px",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "500",
    color: "#6c757d",
    transition: "all 0.3s ease",
  },
  activeTab: {
    padding: "12px 30px",
    margin: "0 10px",
    backgroundColor: "#6e34eb",
    color: "#fff",
    border: "1px solid #5a1ab7",
    borderRadius: "20px",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "bold",
    transition: "all 0.3s ease",
  },
  tabContent: {
    padding: "30px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.05)",
  },
};

export default DashboardMain;
